import ReactLinkify from "react-linkify";

const TextShortenerWithoutButton = ({fullText, words}) => {
    const shortText = `${fullText.split(' ').slice(0, words).join(' ')}`;

    const linkDecorator = (href, text, key) => (
        <a style={{color:"#0251EB",textDecoration:"none"}} href={href} key={key} target="_blank" rel="noopener noreferrer">
          {text}
        </a>
      );

    return ( 
        <pre>
            <ReactLinkify componentDecorator={linkDecorator}>
            {shortText}
            </ReactLinkify>
        </pre>
     );
}
export default TextShortenerWithoutButton;